import UserContext from "Context/UserProvider";
import { useContext, useEffect, useState } from "react";
import { checking_null_undefined } from "utils";
import ElectricVehicleTable from "../../components/fleet/ElectricVehicleComponent/ElectricVehicleTable";
import { Box, Tab, Tabs, CircularProgress } from '@mui/material';
import { useApiService } from "../../services/ApiService/ApiService";

function ElectricVehicleListPage(props: any) {
    const [showCategory] = useState([true, false, false]) as any;
    const { userInfo } = useContext(UserContext);
    const { fetchWithAuth } = useApiService();
    const [rented, setRented] = useState() as any;
    const [fleet, setFleet] = useState() as any;
    const [loading, setLoading] = useState(true);
    const [activeTab, setActiveTab] = useState(0);

    const fetchElectricVehicles = async () => {
        let bodyData: { [name: string]: string } = {};
        bodyData["uuid"] = userInfo.uuid;
        bodyData["businessUuid"] = userInfo.businessUuid;
        bodyData["fleetUuid"] = userInfo.fleetUuid;

        try {
            const response = await fetchWithAuth('/fleet/electric-vehicle/list', {
                method: 'POST',
                body: JSON.stringify(bodyData),
            });

            if (!response.ok) {
                throw new Error('Failed to fetch electric vehicles');
            }

            const res_json = await response.json();
            const connectedFleet = checking_null_undefined(res_json.connectedFleet);

            // Filter for fleet vehicles (ownershipStatus === 'FLEET')
            setFleet(
                connectedFleet
                    .filter((e: any) => e.ownershipStatus === 'FLEET')
                    .map((e: any) => ({
                        ...e,
                        id: e.uuid,
                        registrationNumber: e.registrationNumber,
                        vin: e.vin,
                        make: e.make,
                        model: e.model,
                    }))
            );

            // Filter for rented vehicles (ownershipStatus === 'RENTED')
            setRented(
                connectedFleet
                    .filter((e: any) => e.ownershipStatus === 'RENTED')
                    .map((e: any) => ({
                        ...e,
                        id: e.uuid,
                        registrationNumber: e.registrationNumber,
                        vin: e.vin,
                        make: e.make,
                        model: e.model,
                    }))
            );
        } catch (error) {
            console.error('Error fetching electric vehicles:', error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchElectricVehicles();
    }, []);

    const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
        setActiveTab(newValue);
    };

    if (loading) {
        return (
            <Box 
                component="section" 
                sx={{ px: 3 }}
            >
                <Box display="flex" justifyContent="center" alignItems="center" minHeight="400px">
                    <CircularProgress />
                </Box>
            </Box>
        );
    }

    return (
        <Box 
            component="section"
            sx={{ px: 3 }}
        >
            {showCategory[0] && (
                <Box sx={{ width: '100%' }}>
                    <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                        <Tabs
                            value={activeTab}
                            onChange={handleTabChange}
                            aria-label="vehicle tabs">
                            <Tab label="Fleet" />
                            <Tab label="Rental" />
                        </Tabs>
                    </Box>

                    <Box>
                        {activeTab === 0 && (
                            <ElectricVehicleTable electricVehicles={fleet} />
                        )}
                        {activeTab === 1 && (
                            <ElectricVehicleTable electricVehicles={rented} />
                        )}
                    </Box>
                </Box>
            )}
        </Box>
    );
}

export default ElectricVehicleListPage;
